export default "__VITE_ASSET__D6RFvuvu__"